<template>
   <div class="single-project">
     <div class="container">
      <NuxtLink to="/projets" class="return-link animate__animated animate__fadeInUp animate__slow" >< Retour aux projets</NuxtLink>
    <ElementsLoader  v-if="loading" />
    <div v-else-if="project" v-show="contentReady"  class="animate__animated animate__fadeInUp animate__fast">
      <SingleProjectBanner v-if="project.acf" :title="project.title.rendered" :acf="project.acf" :project="project"/>
      <SingleProjectContent :project="project" :footer="footerTyped" />
      <FormContact/>
    </div>
    </div>
    <MoveUp/>
   </div>
</template>

<script setup lang="ts">
import MoveUp from '~/components/elements/MoveUp.vue';
import type { BlocFooter } from '~/types/options';
import type { Project} from '~/types/projects'

const extractTextFromHtml = (html: string |undefined): string => {
  if (!html) return ''
  
  return html
    .replace(/<[^>]*>/g, ' ') 
    .replace(/&nbsp;/g, ' ')
    .replace(/&[a-z]+;/gi, ' ') 
    .replace(/\s+/g, ' ') 
    .trim()
    .substring(0, 160)
}


const route = useRoute();
const id = route.params.slug as string;
const contentReady = ref(false)
const {getProjectById,getContentAcf} = useWordpressApi()
const loading = ref(true)

const { data: project, pending, error } = await useAsyncData<Project | null>(
  `project-${id}`, 
  () => getProjectById(id),
  {
    server: true, 
    lazy: false,
  }
)
const { data: footer} = await useAsyncData(
  'acf-options-footer',                  
  () => getContentAcf(),
  { transform: (res) => res?.bloc_footer ?? null }
)
const footerTyped = computed(() => footer.value as BlocFooter)
onMounted(()=> {
  contentReady.value = true
  loading.value = false
})

const projectDescription = computed(() => {
  if(!project.value) return 
return extractTextFromHtml(project.value?.acf?.contenu) || 'Découvrez ce projet réalisé par Pauline Fuchs.'
}
   
)


useSeoMeta({
  title: `Pauline Fuchs - ${project.value?.title.rendered}`,
  ogTitle:  `Pauline Fuchs - ${project.value?.title.rendered}`,
  description: projectDescription.value,
  ogDescription: projectDescription.value,
  ogImage: 'https://example.com/image.png',
  twitterCard: 'summary_large_image',
})


</script>

<style lang="scss">

@use '@/assets/scss/wp-page.scss';

.single-project{
  padding: 50px 0;
  min-height: 60vh;
  @media screen and (max-width:1035px) {
    padding: 0;
  }
}
  .return-link{
    color: $text_light;
    font-weight: 600;
    text-decoration: none;
    margin-left: -50px;
    @media screen and (max-width:1035px) {
       margin-left: 0;
  }
  }

</style>